exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".i-m4apn8VLJuTKiPMoXhR .ms-Button-label,.i-m4apn8VLJuTKiPMoXhR .ms-Button-menuIcon{display:none}", ""]);
// Exports
exports.locals = {
	"commandBarAddin": "i-m4apn8VLJuTKiPMoXhR"
};